import { Page } from "@/models/page-models/Page";

export const ProductionOrder: Page = {
  "path": "production-order",
  "name": "Production Order",
  "props": {
    "data": {
      "title": "Production Order",
      "printable": "FALSE",
      "url": "production-order",
      "groups": [
        {
          "type": "tabs",
          "tabItems": [
            {
              "tabName": "Pending FT",
              "bracketValueFormula": "{{fetchedData.ordersPendingFT.data.totalDocs}}",
              "rows": [
                {
                  "name": "1",
                  "pageItems": [
                    {
                      "type": "table",
                      "label": "Pending FT",
                      "disabled": "FALSE",
                      "showIf": "{{fetchedData.ordersPendingFT.data}}",
                      "items": "fetchedData.ordersPendingFT.data.docs",
                      "headers": [
                        {
                          "value": "_id",
                          "text": "Order #",
                          "type": "custom-url",
                          "width": 80,
                          "customUrlFns": [
                            {
                              "executionOrder": 1,
                              "name": "openOrderInNewTab"
                            }
                          ]
                        },
                        {
                          "value": "factoryTicket",
                          "text": "FT #",
                          "type": "url",
                          "url": "/factory-ticket/{{__item.factoryTicket}}"
                        },
                        {
                          "value": "__item.callOff._id",
                          "text": "CallOff #"
                        },
                        {
                          "value": "__item.customerPO",
                          "text": "Customer PO#"
                        },
                        {
                          "value": "__item.deliveryDate",
                          "text": "Delivery Date",
                          "type": "date",
                          "formula": "fn(HELPER_FN,dateFormat,{{__item.deliveryDate}})"
                        },
                        {
                          "value": "__item.customer.name",
                          "text": "Customer",
                          "type": "formula",
                          "formula": "fn(HELPER_FN,customerAlias,{{__item.customer}})",
                          "variableType": "item"
                        },
                        {
                          "value": "__item.product",
                          "text": "Product",
                          "formula": "fn(HELPER_FN,productAlias,{{__item.product}})"
                        },
                        {
                          "value": "__item.product.repeatType",
                          "text": "Product Type",
                          "type": "productRepeatType"
                        },
                        {
                          "value": "__item.unit.unit2",
                          "text": "Unit",
                          "width": 70
                        },
                        {
                          "value": "__item.quantity",
                          "text": "Order Quantity",
                          "type": "formula",
                          "formula": "fn(HELPER_FN,numberAbbreviation,fn(SUM,{{__item.quantity}},{{__item.FOC}}))"
                        },
                        {
                          "value": "balance.totalQuantityProduced",
                          "text": "Produced Qty",
                          "type": "formula",
                          "formula": "fn(HELPER_FN,numberAbbreviation,{{__item.balance.totalQuantityProduced}})"
                        },
                        {
                          "value": "balanceQuantity",
                          "text": "Balance Quantity",
                          "type": "formula",
                          "formula": "fn(HELPER_FN,numberAbbreviation,fn(SUBTRACT,fn(SUM,{{__item.quantity}},{{__item.FOC}}),{{__item.balance.totalQuantityProduced}}))"
                        },
                        {
                          "value": "__item.status",
                          "text": "Order Status"
                        },
                        {
                          "value": "__item.callOff.target",
                          "text": "Target",
                          "formula": "fn(HELPER_FN,orderTarget,{{__item.callOff.target}})"
                        }
                      ],
                      "tableType": "static",
                      "showActions": true,
                      "selectableUniqueId": "_id",
                      "enableSearch": true,
                      "searchFunctions": [
                        {
                          "executionOrder": 1,
                          "pageFunction": {
                            "name": "copyPendingFtSearchString",
                            "type": "fnCopyData",
                            "arg1Key": "sourceKey",
                            "arg1Value": "__item",
                            "arg2Key": "sourceFn",
                            "arg2Value": "getSearchString",
                            "arg3Key": "destinationKey",
                            "arg3Value": "fetchedData.ordersPendingFtForm",
                            "arg4Key": "destinationKeyType",
                            "arg4Value": "Object",
                            "arg5Key": "append",
                            "arg5Value": "TRUE"
                          },
                          "name": "copyPendingFtSearchString"
                        },
                        {
                          "executionOrder": 2,
                          "name": "getOrdersPendingFt"
                        }
                      ],
                      "groupActions": [
                        {
                          "label": "Update Delivery Date",
                          "priority": "main",
                          "showIf": "fn(LOGICAL,fn(MATCH_ROLE,Production | Planner),||,fn(MATCH_ROLE,CUSTOMER_SERVICE_MANAGER))",
                          "disableIf": "fn(LOGICAL,fn(LENGTH,{{__item}}),>,1)",
                          "onClick": [
                            {
                              "executionOrder": 1,
                              "name": "copyDeliveryDate"
                            },
                            {
                              "executionOrder": 1,
                              "name": "copySelectedOrder"
                            },
                            {
                              "executionOrder": 2,
                              "name": "openDeliveryDatePopup"
                            }
                          ]
                        },
                        {
                          "label": "Create Factory Ticket",
                          "priority": "menu",
                          "showIf": "fn(MATCH_ROLE,Production | Planner)",
                          "disableIf": "fn(LOGICAL,fn(LOGICAL,fn(LENGTH,{{__item}}),>,1),||,fn(LOGICAL,{{__item.0.factoryTicket}},!==,0))",
                          "onClick": [
                            {
                              "executionOrder": 1,
                              "name": "redirectToCreateFactoryTicket"
                            }
                          ]
                        },
                        {
                          "label": "Mark As Hold",
                          "showIf": "fn(LOGICAL,fn(NOT,fn(MATCH_ROLE,Customer Service | Artwork)),&&,fn(NOT,fn(MATCH_ROLE,Customer Service | Outbound Warehouse)))",
                          "priority": "menu",
                          "onClick": [
                            {
                              "executionOrder": 1,
                              "name": "markProductionHoldStatus"
                            },
                            {
                              "executionOrder": 2,
                              "name": "getOrdersPendingFt",
                              "executeOnce": true
                            },
                            {
                              "executionOrder": 2,
                              "name": "getOrdersOnHold",
                              "executeOnce": true
                            }
                          ]
                        },
                        {
                          "label": "Cancel Order",
                          "showIf": "fn(MATCH_ROLE,Customer Service | Manager)",
                          "onClick": [
                            {
                              "executionOrder": 1,
                              "name": "cancelOrder"
                            },
                            {
                              "executionOrder": 2,
                              "name": "getOrdersPendingFt",
                              "executeOnce": true
                            }
                          ]
                        },
                        {
                          "label": "Update Customer PO",
                          "showIf": "fn(MATCH_ROLE,Customer Service | Manager)",
                          "disableIf": "fn(LOGICAL,fn(LENGTH,{{__item}}),>,1)",
                          "onClick": [
                            {
                              "executionOrder": 1,
                              "name": "copySelectedOrder"
                            },
                            {
                              "executionOrder": 2,
                              "name": "openCustomerPoPopup"
                            }
                          ]
                        },
                        {
                          "label": "Mark As Complete",
                          "priority": "main",
                          "showIf": "fn(MATCH_ROLE,Customer Service | Manager)",
                          "onClick": [
                            {
                              "executionOrder": 1,
                              "name": "markOrderAsDelivered"
                            },
                            {
                              "executionOrder": 2,
                              "name": "getOrdersUnderProduction",
                              "executeOnce": true
                            }
                          ]
                        }
                      ],
                      "neverHideActionBar": true,
                      "height": "69vh",
                      "pagination": {
                        "pageVariable": "fetchedData.ordersPendingFtForm.page",
                        "serverItemsLengthVariable": "fetchedData.ordersPendingFT.data.totalDocs",
                        "pageChangeFns": [
                          {
                            "executionOrder": 2,
                            "name": "getOrdersPendingFt"
                          }
                        ],
                        "itemsPerPageVariable": "fetchedData.ordersPendingFT.data.limit"
                      }
                    }
                  ]
                }
              ]
            },
            {
              "tabName": "Under Production",
              "bracketValueFormula": "{{fetchedData.ordersUnderProduction.data.totalDocs}}",
              "rows": [
                {
                  "name": "1",
                  "pageItems": [
                    {
                      "type": "table",
                      "label": "Orders Under Production",
                      "disabled": "FALSE",
                      "showIf": "{[fetchedData.ordersUnderProduction.data}}",
                      "items": "fetchedData.ordersUnderProduction.data.docs",
                      "headers": [
                        {
                          "value": "_id",
                          "text": "Order #",
                          "type": "custom-url",
                          "width": 80,
                          "customUrlFns": [
                            {
                              "executionOrder": 1,
                              "name": "openOrderInNewTab"
                            }
                          ]
                        },
                        {
                          "value": "factoryTicket",
                          "text": "FT #",
                          "type": "url",
                          "url": "/factory-ticket/{{__item.factoryTicket}}"
                        },
                        {
                          "value": "__item.callOff._id",
                          "text": "CallOff #"
                        },
                        {
                          "value": "__item.customerPO",
                          "text": "Customer PO#"
                        },
                        {
                          "value": "productionStatusString",
                          "text": "Production Status",
                          "type": "formula",
                          "formula": "fn(HELPER_FN,currentFTProgress,{{__item.currentFTProgress}})"
                        },
                        {
                          "value": "__item.deliveryDate",
                          "text": "Delivery Date",
                          "type": "date",
                          "formula": "fn(HELPER_FN,dateFormat,{{__item.deliveryDate}})"
                        },
                        {
                          "value": "__item.customer.name",
                          "text": "Customer",
                          "type": "formula",
                          "formula": "fn(HELPER_FN,customerAlias,{{__item.customer}})",
                          "variableType": "item"
                        },
                        {
                          "value": "__item.product",
                          "text": "Product",
                          "formula": "fn(HELPER_FN,productAlias,{{__item.product}})"
                        },
                        {
                          "value": "__item.product.repeatType",
                          "text": "Product Type",
                          "type": "productRepeatType"
                        },
                        {
                          "value": "__item.unit.unit2",
                          "text": "Unit",
                          "width": 70
                        },
                        {
                          "value": "__item.quantity",
                          "text": "Order Quantity",
                          "type": "formula",
                          "formula": "fn(HELPER_FN,numberAbbreviation,fn(SUM,{{__item.quantity}},{{__item.FOC}}))"
                        },
                        {
                          "value": "balance.totalQuantityProduced",
                          "text": "Produced Qty",
                          "type": "formula",
                          "formula": "fn(HELPER_FN,numberAbbreviation,{{__item.balance.totalQuantityProduced}})"
                        },
                        {
                          "value": "balanceQuantity",
                          "text": "Balance Quantity",
                          "type": "formula",
                          "formula": "fn(HELPER_FN,numberAbbreviation,fn(SUBTRACT,fn(SUM,{{__item.quantity}},{{__item.FOC}}),{{__item.balance.totalQuantityProduced}}))"
                        },
                        {
                          "value": "__item.status",
                          "text": "Order Status"
                        },
                        {
                          "value": "__item.callOff.target",
                          "text": "Target",
                          "formula": "fn(HELPER_FN,orderTarget,{{__item.callOff.target}})"
                        }
                      ],
                      "tableType": "static",
                      "showActions": true,
                      "selectableUniqueId": "_id",
                      "enableSearch": true,
                      "searchFunctions": [
                        {
                          "executionOrder": 1,
                          "pageFunction": {
                            "name": "copyOrderUnderProductionSearchString",
                            "type": "fnCopyData",
                            "arg1Key": "sourceKey",
                            "arg1Value": "__item",
                            "arg2Key": "sourceFn",
                            "arg2Value": "getSearchString",
                            "arg3Key": "destinationKey",
                            "arg3Value": "fetchedData.ordersUnderProductionForm",
                            "arg4Key": "destinationKeyType",
                            "arg4Value": "Object",
                            "arg5Key": "append",
                            "arg5Value": "TRUE"
                          },
                          "name": "copyOrderUnderProductionSearchString"
                        },
                        {
                          "executionOrder": 2,
                          "name": "getOrdersUnderProduction"
                        }
                      ],
                      "groupActions": [
                        {
                          "label": "Update Delivery Date",
                          "priority": "main",
                          "showIf": "fn(LOGICAL,fn(MATCH_ROLE,Production | Planner),||,fn(MATCH_ROLE,CUSTOMER_SERVICE_MANAGER))",
                          "disableIf": "fn(LOGICAL,fn(LENGTH,{{__item}}),>,1)",
                          "onClick": [
                            {
                              "executionOrder": 1,
                              "name": "copyDeliveryDate"
                            },
                            {
                              "executionOrder": 1,
                              "name": "copySelectedOrder"
                            },
                            {
                              "executionOrder": 2,
                              "name": "openDeliveryDatePopup"
                            }
                          ]
                        },
                        {
                          "label": "Create Factory Ticket",
                          "priority": "menu",
                          "showIf": "fn(MATCH_ROLE,Production | Planner)",
                          "disableIf": "fn(LOGICAL,fn(LOGICAL,fn(LENGTH,{{__item}}),>,1),||,fn(LOGICAL,{{__item.0.factoryTicket}},!==,0))",
                          "onClick": [
                            {
                              "executionOrder": 1,
                              "name": "redirectToCreateFactoryTicket"
                            }
                          ]
                        },
                        {
                          "label": "Mark As Hold",
                          "priority": "menu",
                          "showIf": "fn(LOGICAL,fn(NOT,fn(MATCH_ROLE,Customer Service | Artwork)),&&,fn(NOT,fn(MATCH_ROLE,Customer Service | Outbound Warehouse)))",
                          "onClick": [
                            {
                              "executionOrder": 1,
                              "name": "markProductionHoldStatus"
                            },
                            {
                              "executionOrder": 2,
                              "name": "getOrdersUnderProduction",
                              "executeOnce": true
                            },
                            {
                              "executionOrder": 2,
                              "name": "getOrdersOnHold",
                              "executeOnce": true
                            }
                          ]
                        },
                        {
                          "label": "Cancel Order",
                          "showIf": "fn(MATCH_ROLE,Customer Service | Manager)",
                          "onClick": [
                            {
                              "executionOrder": 1,
                              "name": "cancelOrder"
                            },
                            {
                              "executionOrder": 2,
                              "name": "getOrdersUnderProduction",
                              "executeOnce": true
                            }
                          ]
                        },
                        {
                          "label": "Update Customer PO",
                          "showIf": "fn(MATCH_ROLE,Customer Service | Manager)",
                          "disableIf": "fn(LOGICAL,fn(LENGTH,{{__item}}),>,1)",
                          "onClick": [
                            {
                              "executionOrder": 1,
                              "name": "copySelectedOrder"
                            },
                            {
                              "executionOrder": 2,
                              "name": "openCustomerPoPopup"
                            }
                          ]
                        },
                        {
                          "label": "Mark As Complete",
                          "priority": "main",
                          "showIf": "fn(MATCH_ROLE,Customer Service | Manager)",
                          "onClick": [
                            {
                              "executionOrder": 1,
                              "name": "markOrderAsDelivered"
                            },
                            {
                              "executionOrder": 2,
                              "name": "getOrdersUnderProduction",
                              "executeOnce": true
                            }
                          ]
                        }
                      ],
                      "neverHideActionBar": true,
                      "height": "69vh",
                      "pagination": {
                        "pageVariable": "fetchedData.ordersUnderProductionForm.page",
                        "serverItemsLengthVariable": "fetchedData.ordersUnderProduction.data.totalDocs",
                        "pageChangeFns": [
                          {
                            "executionOrder": 2,
                            "name": "getOrdersUnderProduction"
                          }
                        ],
                        "itemsPerPageVariable": "fetchedData.ordersUnderProduction.data.limit"
                      }
                    }
                  ]
                }
              ]
            },
            {
              "tabName": "On Hold",
              "bracketValueFormula": "{{fetchedData.ordersOnHold.data.totalDocs}}",
              "rows": [
                {
                  "name": "1",
                  "pageItems": [
                    {
                      "type": "table",
                      "label": "Orders On Hold",
                      "disabled": "FALSE",
                      "showIf": "{{fetchedData.ordersOnHold.data}}",
                      "items": "fetchedData.ordersOnHold.data.docs",
                      "headers": [
                        {
                          "value": "_id",
                          "text": "Order #",
                          "type": "custom-url",
                          "width": 80,
                          "customUrlFns": [
                            {
                              "executionOrder": 1,
                              "name": "openOrderInNewTab"
                            }
                          ]
                        },
                        {
                          "value": "factoryTicket",
                          "text": "FT #",
                          "type": "url",
                          "url": "/factory-ticket/{{__item.factoryTicket}}"
                        },
                        {
                          "value": "__item.callOff._id",
                          "text": "CallOff #"
                        },
                        {
                          "value": "__item.customerPO",
                          "text": "Customer PO#"
                        },
                        {
                          "value": "productionStatusString",
                          "text": "Production Status",
                          "type": "formula",
                          "formula": "fn(HELPER_FN,currentFTProgress,{{__item.currentFTProgress}})"
                        },
                        {
                          "value": "__item.deliveryDate",
                          "text": "Delivery Date",
                          "type": "date",
                          "formula": "fn(HELPER_FN,dateFormat,{{__item.deliveryDate}})"
                        },
                        {
                          "value": "__item.customer.name",
                          "text": "Customer",
                          "type": "formula",
                          "formula": "fn(HELPER_FN,customerAlias,{{__item.customer}})",
                          "variableType": "item"
                        },
                        {
                          "value": "__item.product",
                          "text": "Product",
                          "formula": "fn(HELPER_FN,productAlias,{{__item.product}})"
                        },
                        {
                          "value": "__item.product.repeatType",
                          "text": "Product Type",
                          "type": "productRepeatType"
                        },
                        {
                          "value": "__item.unit.unit2",
                          "text": "Unit",
                          "width": 70
                        },
                        {
                          "value": "__item.quantity",
                          "text": "Order Quantity",
                          "type": "formula",
                          "formula": "fn(HELPER_FN,numberAbbreviation,fn(SUM,{{__item.quantity}},{{__item.FOC}}))"
                        },
                        {
                          "value": "balance.totalQuantityProduced",
                          "text": "Produced Qty",
                          "type": "formula",
                          "formula": "fn(HELPER_FN,numberAbbreviation,{{__item.balance.totalQuantityProduced}})"
                        },
                        {
                          "value": "balanceQuantity",
                          "text": "Balance Quantity",
                          "type": "formula",
                          "formula": "fn(HELPER_FN,numberAbbreviation,fn(SUBTRACT,fn(SUM,{{__item.quantity}},{{__item.FOC}}),{{__item.balance.totalQuantityProduced}}))"
                        },
                        {
                          "value": "__item.status",
                          "text": "Order Status"
                        },
                        {
                          "value": "__item.callOff.target",
                          "text": "Target",
                          "formula": "fn(HELPER_FN,orderTarget,{{__item.callOff.target}})"
                        }
                      ],
                      "tableType": "static",
                      "showActions": true,
                      "selectableUniqueId": "_id",
                      "enableSearch": true,
                      "searchFunctions": [
                        {
                          "executionOrder": 1,
                          "pageFunction": {
                            "name": "copyOrdersOnHoldSearchString",
                            "type": "fnCopyData",
                            "arg1Key": "sourceKey",
                            "arg1Value": "__item",
                            "arg2Key": "sourceFn",
                            "arg2Value": "getSearchString",
                            "arg3Key": "destinationKey",
                            "arg3Value": "fetchedData.ordersOnHoldForm",
                            "arg4Key": "destinationKeyType",
                            "arg4Value": "Object",
                            "arg5Key": "append",
                            "arg5Value": "TRUE"
                          },
                          "name": "copyOrdersOnHoldSearchString"
                        },
                        {
                          "executionOrder": 2,
                          "name": "getOrdersOnHold"
                        }
                      ],
                      "groupActions": [
                        {
                          "label": "Cancel Order",
                          "showIf": "fn(MATCH_ROLE,Customer Service | Manager)",
                          "onClick": [
                            {
                              "executionOrder": 1,
                              "name": "cancelOrder"
                            },
                            {
                              "executionOrder": 2,
                              "name": "getOrdersOnHold",
                              "executeOnce": true
                            }
                          ]
                        },
                        {
                          "label": "Mark As Under Production",
                          "priority": "menu",
                          "showIf": "fn(LOGICAL,fn(MATCH_ROLE,Production | Manager),||,fn(MATCH_ROLE,Customer Service | Manager))",
                          "disableIf": "fn(LOGICAL,fn(LENGTH,{{__item}}),<,1)",
                          "onClick": [
                            {
                              "executionOrder": 1,
                              "name": "markAsUnderProduction"
                            },
                            {
                              "executionOrder": 2,
                              "name": "getOrdersPendingFt",
                              "executeOnce": true
                            },
                            {
                              "executionOrder": 2,
                              "name": "getOrdersUnderProduction",
                              "executeOnce": true
                            },
                            {
                              "executionOrder": 2,
                              "name": "getOrdersOnHold",
                              "executeOnce": true
                            },
                            {
                              "executionOrder": 2,
                              "name": "getOrdersPendingCompletion",
                              "executeOnce": true
                            }
                          ]
                        }
                      ],
                      "neverHideActionBar": true,
                      "height": "69vh",
                      "pagination": {
                        "pageVariable": "fetchedData.ordersOnHoldForm.page",
                        "serverItemsLengthVariable": "fetchedData.ordersOnHold.data.totalDocs",
                        "pageChangeFns": [
                          {
                            "executionOrder": 2,
                            "name": "getOrdersOnHold"
                          }
                        ],
                        "itemsPerPageVariable": "fetchedData.ordersOnHold.data.limit"
                      }
                    }
                  ]
                }
              ],
              "showIf": "fn(NOT,fn(MATCH_ROLE,Customer Service | Outbound Warehouse))"
            },
            {
              "tabName": "Pending Completion",
              "bracketValueFormula": "{{fetchedData.ordersPendingCompletion.data.totalDocs}}",
              "rows": [
                {
                  "name": "1",
                  "pageItems": [
                    {
                      "type": "table",
                      "label": "Orders Pending Dispatch",
                      "disabled": "FALSE",
                      "showIf": "{{fetchedData.ordersPendingCompletion.data}}",
                      "items": "fetchedData.ordersPendingCompletion.data.docs",
                      "headers": [
                        {
                          "value": "_id",
                          "text": "Order #",
                          "type": "custom-url",
                          "width": 80,
                          "customUrlFns": [
                            {
                              "executionOrder": 1,
                              "name": "openOrderInNewTab"
                            }
                          ]
                        },
                        {
                          "value": "factoryTicket",
                          "text": "FT #",
                          "type": "url",
                          "url": "/factory-ticket/{{__item.factoryTicket}}"
                        },
                        {
                          "value": "__item.callOff._id",
                          "text": "CallOff #"
                        },
                        {
                          "value": "__item.customerPO",
                          "text": "Customer PO#"
                        },
                        {
                          "value": "productionStatusString",
                          "text": "Production Status",
                          "type": "formula",
                          "formula": "fn(HELPER_FN,currentFTProgress,{{__item.currentFTProgress}})"
                        },
                        {
                          "value": "__item.deliveryDate",
                          "text": "Delivery Date",
                          "type": "date",
                          "formula": "fn(HELPER_FN,dateFormat,{{__item.deliveryDate}})"
                        },
                        {
                          "value": "__item.customer.name",
                          "text": "Customer",
                          "type": "formula",
                          "formula": "fn(HELPER_FN,customerAlias,{{__item.customer}})",
                          "variableType": "item"
                        },
                        {
                          "value": "__item.product",
                          "text": "Product",
                          "formula": "fn(HELPER_FN,productAlias,{{__item.product}})"
                        },
                        {
                          "value": "__item.product.repeatType",
                          "text": "Product Type",
                          "type": "productRepeatType"
                        },
                        {
                          "value": "__item.unit.unit2",
                          "text": "Unit",
                          "width": 70
                        },
                        {
                          "value": "__item.quantity",
                          "text": "Order Quantity",
                          "type": "formula",
                          "formula": "fn(HELPER_FN,numberAbbreviation,fn(SUM,{{__item.quantity}},{{__item.FOC}}))"
                        },
                        {
                          "value": "balance.totalQuantityProduced",
                          "text": "Produced Qty",
                          "type": "formula",
                          "formula": "fn(HELPER_FN,numberAbbreviation,{{__item.balance.totalQuantityProduced}})"
                        },
                        {
                          "value": "balanceQuantity",
                          "text": "Balance Quantity",
                          "type": "formula",
                          "formula": "fn(HELPER_FN,numberAbbreviation,fn(SUBTRACT,fn(SUM,{{__item.quantity}},{{__item.FOC}}),{{__item.balance.totalQuantityProduced}}))"
                        },
                        {
                          "value": "__item.status",
                          "text": "Order Status"
                        },
                        {
                          "value": "__item.callOff.target",
                          "text": "Target",
                          "formula": "fn(HELPER_FN,orderTarget,{{__item.callOff.target}})"
                        }
                      ],
                      "tableType": "static",
                      "showActions": true,
                      "selectableUniqueId": "_id",
                      "enableSearch": true,
                      "searchFunctions": [
                        {
                          "executionOrder": 1,
                          "pageFunction": {
                            "name": "copyOrdersPendingCompletionSearchString",
                            "type": "fnCopyData",
                            "arg1Key": "sourceKey",
                            "arg1Value": "__item",
                            "arg2Key": "sourceFn",
                            "arg2Value": "getSearchString",
                            "arg3Key": "destinationKey",
                            "arg3Value": "fetchedData.ordersPendingCompletionForm",
                            "arg4Key": "destinationKeyType",
                            "arg4Value": "Object",
                            "arg5Key": "append",
                            "arg5Value": "TRUE"
                          },
                          "name": "copyOrdersPendingCompletionSearchString"
                        },
                        {
                          "executionOrder": 2,
                          "name": "getOrdersPendingCompletion"
                        }
                      ],
                      "groupActions": [
                        {
                          "label": "Update Delivery Date",
                          "priority": "main",
                          "showIf": "fn(LOGICAL,fn(MATCH_ROLE,Production | Planner),||,fn(MATCH_ROLE,CUSTOMER_SERVICE_MANAGER))",
                          "disableIf": "fn(LOGICAL,fn(LENGTH,{{__item}}),>,1)",
                          "onClick": [
                            {
                              "executionOrder": 1,
                              "name": "copyDeliveryDate"
                            },
                            {
                              "executionOrder": 1,
                              "name": "copySelectedOrder"
                            },
                            {
                              "executionOrder": 2,
                              "name": "openDeliveryDatePopup"
                            }
                          ]
                        },
                        {
                          "label": "Mark As Complete",
                          "priority": "main",
                          "showIf": "fn(MATCH_ROLE,Customer Service | Manager)",
                          "onClick": [
                            {
                              "executionOrder": 1,
                              "name": "markOrderAsDelivered"
                            },
                            {
                              "executionOrder": 2,
                              "name": "getOrdersPendingCompletion",
                              "executeOnce": true
                            }
                          ]
                        },
                        {
                          "label": "Cancel Order",
                          "showIf": "fn(MATCH_ROLE,Customer Service | Manager)",
                          "onClick": [
                            {
                              "executionOrder": 1,
                              "name": "cancelOrder"
                            },
                            {
                              "executionOrder": 2,
                              "name": "getOrdersPendingCompletion",
                              "executeOnce": true
                            }
                          ]
                        },
                        {
                          "label": "Update Customer PO",
                          "showIf": "fn(MATCH_ROLE,Customer Service | Manager)",
                          "disableIf": "fn(LOGICAL,fn(LENGTH,{{__item}}),>,1)",
                          "onClick": [
                            {
                              "executionOrder": 1,
                              "name": "copySelectedOrder"
                            },
                            {
                              "executionOrder": 2,
                              "name": "openCustomerPoPopup"
                            }
                          ]
                        }
                      ],
                      "neverHideActionBar": true,
                      "height": "69vh",
                      "pagination": {
                        "pageVariable": "fetchedData.ordersPendingCompletionForm.page",
                        "serverItemsLengthVariable": "fetchedData.ordersPendingCompletion.data.totalDocs",
                        "pageChangeFns": [
                          {
                            "executionOrder": 2,
                            "name": "getOrdersPendingCompletion"
                          }
                        ],
                        "itemsPerPageVariable": "fetchedData.ordersPendingCompletion.data.limit"
                      }
                    }
                  ]
                }
              ]
            }
          ]
        },
        {
          "type": "popupGroup",
          "label": "Change Delivery Date",
          "popupItems": [
            {
              "name": "1",
              "pageItems": [
                {
                  "type": "label",
                  "variable": "fetchedData.selectedOrder",
                  "labelType": "formula",
                  "formula": "fn(HELPER_FN,orderDescription,{{fetchedData.selectedOrder}})"
                },
                {
                  "type": "datepicker",
                  "variable": "formData.deliveryDate",
                  "label": "Delivery Date",
                  "disabled": "FALSE"
                }
              ]
            }
          ],
          "popupActions": [
            {
              "label": "Submit",
              "onClick": [
                {
                  "executionOrder": 1,
                  "name": "submitDeliveryDate"
                },
                {
                  "executionOrder": 2,
                  "name": "closeDeliveryDatePopup"
                }
              ]
            }
          ],
          "width": "500"
        },
        {
          "type": "popupGroup",
          "label": "Update Customer PO",
          "popupItems": [
            {
              "name": "1",
              "pageItems": [
                {
                  "type": "input",
                  "variable": "formData.customerPO",
                  "label": "Customer PO",
                  "disabled": "FALSE"
                }
              ]
            }
          ],
          "popupActions": [
            {
              "label": "Update",
              "onClick": [
                {
                  "executionOrder": 1,
                  "name": "updateCustomerPO"
                },
                {
                  "executionOrder": 2,
                  "name": "closeCustomerPoPopup"
                }
              ]
            }
          ],
          "width": "500"
        }
      ],
      "useMaxPageWidth": true
    },
    "initialFunctionsCalled": [
      {
        "executionOrder": 1,
        "name": "copyOrdersPendingFtForm"
      },
      {
        "executionOrder": 2,
        "name": "getOrdersPendingFt"
      },
      {
        "executionOrder": 1,
        "name": "copyOrdersUnderProductionForm"
      },
      {
        "executionOrder": 2,
        "name": "getOrdersUnderProduction"
      },
      {
        "executionOrder": 1,
        "name": "copyOrdersOnHoldForm",
        "executeIf": "fn(NOT,fn(MATCH_ROLE,Customer Service | Outbound Warehouse))"
      },
      {
        "executionOrder": 2,
        "name": "getOrdersOnHold",
        "executeIf": "fn(NOT,fn(MATCH_ROLE,Customer Service | Outbound Warehouse))"
      },
      {
        "executionOrder": 1,
        "name": "copyOrdersPendingCompletionForm"
      },
      {
        "executionOrder": 2,
        "name": "getOrdersPendingCompletion"
      }
    ],
    "functions": [
      {
        "name": "getOrdersPendingFt",
        "type": "fnGetData",
        "arg1Key": "apiUrl",
        "arg1Value": "/api/v1/order/get?orderStatus=Unplanned&orderStatus=Pending+FT&page={{fetchedData.ordersPendingFtForm.page}}&limit={{fetchedData.ordersPendingFtForm.limit}}&search={{fetchedData.ordersPendingFtForm.search}}",
        "arg2Key": "storeInVar",
        "arg2Value": "fetchedData.ordersPendingFT",
        "arg3Key": "postData",
        "arg3Value": "{}"
      },
      {
        "name": "getOrdersUnderProduction",
        "type": "fnGetData",
        "arg1Key": "apiUrl",
        "arg1Value": "/api/v1/order/get",
        "arg2Key": "storeInVar",
        "arg2Value": "fetchedData.ordersUnderProduction",
        "arg3Key": "postData",
        "arg3Value": "fetchedData.ordersUnderProductionForm"
      },
      {
        "name": "getOrdersOnHold",
        "type": "fnGetData",
        "arg1Key": "apiUrl",
        "arg1Value": "/api/v1/order/get",
        "arg2Key": "storeInVar",
        "arg2Value": "fetchedData.ordersOnHold",
        "arg3Key": "postData",
        "arg3Value": "fetchedData.ordersOnHoldForm"
      },
      {
        "name": "getOrdersPendingCompletion",
        "type": "fnGetData",
        "arg1Key": "apiUrl",
        "arg1Value": "/api/v1/order/get",
        "arg2Key": "storeInVar",
        "arg2Value": "fetchedData.ordersPendingCompletion",
        "arg3Key": "postData",
        "arg3Value": "fetchedData.ordersPendingCompletionForm"
      },
      {
        "name": "copyDeliveryDate",
        "type": "fnCopyData",
        "arg1Key": "sourceFn",
        "arg1Value": "getDeliveryDate",
        "arg2Key": "destinationKey",
        "arg2Value": "formData",
        "arg3Key": "destinationKeyType",
        "arg3Value": "Object",
        "arg4Key": "append",
        "arg4Value": "TRUE",
        "arg5Key": "sourceKey",
        "arg5Value": "__item"
      },
      {
        "name": "copySelectedOrder",
        "type": "fnCopyData",
        "arg1Key": "sourceKey",
        "arg1Value": "__item",
        "arg2Key": "destinationKey",
        "arg2Value": "fetchedData.selectedOrder"
      },
      {
        "name": "getDeliveryDate",
        "type": "fnCreateObjectFromKeys",
        "newKeyValues": {
          "deliveryDate": "fn(HELPER_FN,dateFormat,{{__selectedObject.deliveryDate}},date-picker)"
        },
        "useFormula": true
      },
      {
        "name": "openDeliveryDatePopup",
        "type": "fnOpenPopup",
        "arg1Key": "popupName",
        "arg1Value": "Change Delivery Date"
      },
      {
        "name": "closeDeliveryDatePopup",
        "type": "fnClosePopup",
        "arg1Key": "popupName",
        "arg1Value": "Change Delivery Date"
      },
      {
        "name": "submitDeliveryDate",
        "type": "fnSubmit",
        "arg1Key": "apiUrl",
        "arg1Value": "/api/v1/order/update/{{fetchedData.selectedOrder._id}}/delivery-date",
        "arg2Key": "postData",
        "arg2Value": "formData",
        "arg3Key": "refreshPage",
        "arg3Value": "TRUE"
      },
      {
        "name": "redirectToCreateFactoryTicket",
        "type": "fnRedirect",
        "arg1Key": "redirectUrl",
        "arg1Value": "/factory-ticket",
        "arg2Key": "queryParams",
        "arg2Value": "{\"order\":\"{{__selectedObject._id}}\"}"
      },
      {
        "name": "markProductionHoldStatus",
        "type": "fnSubmit",
        "arg1Key": "apiUrl",
        "arg1Value": "/api/v2/order/{{__item._id}}/mark-production-hold",
        "arg2Key": "postData",
        "arg2Value": "\"{}\""
      },
      {
        "name": "markOrderAsDelivered",
        "type": "fnSubmit",
        "arg1Key": "apiUrl",
        "arg1Value": "/api/v2/order/{{__item._id}}/mark-delivered",
        "arg2Key": "postData",
        "arg2Value": "\"{}\""
      },
      {
        "name": "cancelOrder",
        "type": "fnSubmit",
        "arg1Key": "apiUrl",
        "arg1Value": "/api/v2/order/{{__item._id}}/cancel-production-order",
        "arg2Key": "postData",
        "arg2Value": "\"{}\""
      },
      {
        "name": "markAsUnderProduction",
        "type": "fnSubmit",
        "arg1Key": "apiUrl",
        "arg1Value": "/api/v2/order/{{__item._id}}/mark-under-production",
        "arg2Key": "postData",
        "arg2Value": "\"{}\""
      },
      {
        "name": "openOrderInNewTab",
        "type": "fnRedirect",
        "arg1Key": "redirectUrl",
        "arg1Value": "/order/{{__item._id}}",
        "arg2Key": "openNewTab",
        "arg2Value": "TRUE"
      },
      {
        "name": "openCustomerPoPopup",
        "type": "fnOpenPopup",
        "arg1Key": "popupName",
        "arg1Value": "Update Customer PO"
      },
      {
        "name": "updateCustomerPO",
        "type": "fnSubmit",
        "arg1Key": "apiUrl",
        "arg1Value": "/api/v1/order/{{fetchedData.selectedOrder._id}}/update-customer-po\n",
        "arg2Key": "refreshPage",
        "arg2Value": "TRUE"
      },
      {
        "name": "closeCustomerPoPopup",
        "type": "fnClosePopup",
        "arg1Key": "popupName",
        "arg1Value": "Update Customer PO"
      },
      {
        "name": "copyOrdersPendingFtForm",
        "type": "fnCopyData",
        "arg1Key": "sourceFn",
        "arg1Value": "getOrdersPendingFtForm",
        "arg2Key": "destinationKey",
        "arg2Value": "fetchedData.ordersPendingFtForm",
        "arg4Key": "destinationKeyType",
        "arg4Value": "Object"
      },
      { 
        "name": "getOrdersPendingFtForm",
        "type": "fnCreateObjectFromKeys",
        "newKeyValues": {
          "page": 1,
          "limit": 50,
          "search": ""
        },
        "staticObject": true
      },
      {
        "name": "copyOrdersUnderProductionForm",
        "type": "fnCopyData",
        "arg1Key": "sourceFn",
        "arg1Value": "getOrdersUnderProductionForm",
        "arg2Key": "destinationKey",
        "arg2Value": "fetchedData.ordersUnderProductionForm",
        "arg4Key": "destinationKeyType",
        "arg4Value": "Object"
      },
      { 
        "name": "getOrdersUnderProductionForm",
        "type": "fnCreateObjectFromKeys",
        "newKeyValues": {
          "page": 1,
          "limit": 50,
          "orderStatus": "Under Production"
        },
        "staticObject": true
      },
      {
        "name": "copyOrdersOnHoldForm",
        "type": "fnCopyData",
        "arg1Key": "sourceFn",
        "arg1Value": "getOrdersOnHoldForm",
        "arg2Key": "destinationKey",
        "arg2Value": "fetchedData.ordersOnHoldForm",
        "arg4Key": "destinationKeyType",
        "arg4Value": "Object"
      },
      { 
        "name": "getOrdersOnHoldForm",
        "type": "fnCreateObjectFromKeys",
        "newKeyValues": {
          "page": 1,
          "limit": 50,
          "orderStatus": "Hold"
        },
        "staticObject": true
      },
      {
        "name": "copyOrdersPendingCompletionForm",
        "type": "fnCopyData",
        "arg1Key": "sourceFn",
        "arg1Value": "getOrdersPendingCompletionForm",
        "arg2Key": "destinationKey",
        "arg2Value": "fetchedData.ordersPendingCompletionForm",
        "arg4Key": "destinationKeyType",
        "arg4Value": "Object"
      },
      { 
        "name": "getOrdersPendingCompletionForm",
        "type": "fnCreateObjectFromKeys",
        "newKeyValues": {
          "page": 1,
          "limit": 50,
          "orderStatus": "Pending Completion"
        },
        "staticObject": true
      },
      {
        "name": "getSearchString",
        "type": "fnCreateObjectFromKeys",
        "newKeyValues": {
          "page": "1",
          "search": "{{__selectedObject}}"
        },
        "useFormula": true
      }
    ]
  },
  "forRole": "PRODUCTION_MANAGER,PRODUCTION_PLANNER,CUSTOMER_SERVICE_ARTWORK,CUSTOMER_SERVICE_MANAGER,CUSTOMER_SERVICE_OUTBOUND_WAREHOUSE",
  "visible": true,
  "routerPriority": 100
}